import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Grid, Tab, Tabs, Typography } from "@mui/material";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import {
  findGetParameter,
  getData,
  newPath,
} from "../../components/utilities/UtilityFunctions";
import ListResponsive from "../../components/other/ListResponsive";
import StoreTransactionsList from "./components/StoreTransactionsList";
import { setLoyaltyPoints } from "../../components/user/BCPAuth";
import TabPanel, { tabPanelA11yProps } from "../../components/layout/TabPanel";

const tabIndexes = {
  account: 0,
  transactions: 1,
  adjustments: 2,
  judging: 3,
};

export default function StoreAccount(params) {
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const activeTabParam = findGetParameter("active_tab");

  const [activeTab, setActiveTab] = useState(
    activeTabParam
      ? tabIndexes[activeTabParam.toLowerCase()] !== undefined
        ? tabIndexes[activeTabParam.toLowerCase()]
        : 0
      : 0
  );
  const handleTabChange = async (e, newValue) => {
    setLoading(true);
    var path;
    Object.keys(tabIndexes).forEach((tabIndex) => {
      if (tabIndexes[tabIndex] === newValue) {
        path = newPath({
          active_tab: tabIndex,
        });

        return true;
      }
    });
    setActiveTab(newValue);
    navigate(path, { replace: false });
    setLoading(false);
  };

  useEffect(() => {
    const go = async () => {
      var apiUser = await getData(
        `/users/${authContext?.authState?.identity?.userId}`,
        {
          queryStringParameters: {},
        }
      );

      setLoyaltyPoints(apiUser?.loyaltyPoints || {});
      setUser(apiUser);
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {Boolean(loading) && <ModalLoadingFull />}
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            maxWidth: "100%",
            
            backgroundColor:
               "banner.main",
            color:
               "banner.contrastText",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Container maxWidth="lg">
            <Grid container alignItems="center">
              <Grid item xs={12}>
                <Typography variant="h3" gutterBottom>
                  Shop
                </Typography>
              </Grid>
            </Grid>

            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="loyalty tabs"
            >
              <Tab label="Account" {...tabPanelA11yProps(0)} />
              <Tab label="Transactions" {...tabPanelA11yProps(1)} />
              <Tab label="Adjustments" {...tabPanelA11yProps(2)} />
              <Tab label="Judging" {...tabPanelA11yProps(3)} />
            </Tabs>
          </Container>
        </Box>
        <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
          <TabPanel value={activeTab} index={0}>
            {user && (
              <AccountDetailsTab user={user} authContext={authContext} />
            )}
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            {user && activeTab === 1 && (
              <OrdersTab user={user} authContext={authContext} />
            )}
          </TabPanel>
          <TabPanel value={activeTab} index={2}>
            {user && activeTab === 2 && (
              <AdjustmentsTab user={user} authContext={authContext} />
            )}
          </TabPanel>
          <TabPanel value={activeTab} index={3}>
            {user && activeTab === 3 && (
              <JudgingTab user={user} authContext={authContext} />
            )}
          </TabPanel>
        </Container>
      </Box>
    </>
  );
}

function AccountDetailsTab(props) {
  const { user } = props;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing] = useState(false);

  useEffect(() => {
    const go = async () => {
      setLoading(true);
      setRows([
        {
          label: "Earnt",
          value: `${user?.loyaltyPoints?.earnt || 0} LP`,
        },
        {
          label: "Judge Points",
          value: `${user?.loyaltyPoints?.judging || 0} LP`,
        },
        {
          label: "Spent",
          value: `${user?.loyaltyPoints?.spent || 0} LP`,
        },
        {
          label: "Adjustments",
          value: `${user?.loyaltyPoints?.adjustments || 0} LP`,
        },
        {
          label: "Balance",
          value: `${user?.loyaltyPoints?.available || 0} LP`,
        },
      ]);
      setLoading(false);
    };
    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ListResponsive
        originalList={rows}
        rowProps={{
          mapFunction: (row, index) => (
            <Grid key={index} item xs={12}>
              <Grid
                container
                spacing={1}
                sx={{
                  p: 1,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                }}
              >
                <Grid item xs={6}>
                  <Typography variant="body1">{row.label}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">{row.value}</Typography>
                </Grid>
              </Grid>
            </Grid>
          ),
        }}
      />
      {(loading || processing) && <ModalLoadingFull />}
    </>
  );
}

function OrdersTab(props) {
  const { user } = props;
  return (
    <StoreTransactionsList
      query={{
        userId: user.id,
        transactionTypes: JSON.stringify(["Order", "Refund"]),
        sortAscending: false,
      }}
    />
  );
}

function AdjustmentsTab(props) {
  const { user } = props;

  return (
    <StoreTransactionsList
      query={{
        userId: user.id,
        transactionType: "Adjustment",
        sortAscending: false,
      }}
    />
  );
}

function JudgingTab(props) {
  const { user } = props;

  return (
    <StoreTransactionsList
      query={{
        userId: user.id,
        transactionType: "Judging",
        sortAscending: false,
      }}
    />
  );
}
